import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

export const Navigation = (props) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      {/* Banner superior mejorado */}
      <div style={{
        width: '100%',
        height: '120px',
        background: 'linear-gradient(135deg,rgb(31, 66, 226) 0%,rgb(38, 232, 51) 100%)',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1030,
        boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundImage: 'url(/img/mediobanner.png)',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: '80%',
          filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))'
        }}></div>
        
        {/* Elementos decorativos */}
        <div style={{
          position: 'absolute',
          top: '10px',
          left: '20px',
          width: '30px',
          height: '30px',
          background: 'rgba(255,255,255,0.2)',
          borderRadius: '50%'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '15px',
          right: '30px',
          width: '20px',
          height: '20px',
          background: 'rgba(255,255,255,0.15)',
          borderRadius: '50%'
        }}></div>
      </div>
      
      {/* Navegación mejorada */}
      <nav 
        id="menu" 
        className="navbar navbar-default navbar-fixed-top" 
        style={{ 
          top: '120px',
          background: scrolled ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease',
          boxShadow: scrolled ? '0 5px 25px rgba(0,0,0,0.1)' : '0 2px 10px rgba(0,0,0,0.05)',
          borderBottom: scrolled ? '3px solid #3498db' : '1px solid rgba(0,0,0,0.1)'
        }}
      >
        <div className="container">
          <div className="navbar-header">
            {/* Botón móvil mejorado */}
            <button
              type="button"
              className="navbar-toggle"
              onClick={toggleMobileMenu}
              style={{
                background: 'linear-gradient(135deg, #3498db, #2980b9)',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 12px',
                transition: 'all 0.3s ease'
              }}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" style={{ background: 'white' }}></span>
              <span className="icon-bar" style={{ background: 'white' }}></span>
              <span className="icon-bar" style={{ background: 'white' }}></span>
            </button>
           
          </div>

          <div
            className={`collapse navbar-collapse ${mobileMenuOpen ? 'in' : ''}`}
            id="bs-example-navbar-collapse-1"
            style={{
              background: mobileMenuOpen ? 'rgba(255,255,255,0.98)' : 'transparent',
              borderRadius: mobileMenuOpen ? '10px' : '0',
              marginTop: mobileMenuOpen ? '10px' : '0',
              boxShadow: mobileMenuOpen ? '0 10px 30px rgba(0,0,0,0.1)' : 'none',
              transition: 'all 0.3s ease'
            }}
          >
            <ul className="nav navbar-nav navbar-right">
              {[
                { href: "#primary-services", text: "🚀 Servicios", color: "#3498db" },
                { href: "#features", text: "⭐ Características", color: "#e74c3c" },
                { href: "#about", text: "👥 Nosotros", color: "#2ecc71" },
                { href: "#services", text: "🛠️ Servicios", color: "#f39c12" },
                { href: "#portfolio", text: "📸 Galería", color: "#9b59b6" },
                { href: "#testimonials", text: "💬 Testimonios", color: "#1abc9c" },
                { href: "#team", text: "👨‍💼 Equipo", color: "#34495e" },
                { href: "#contact", text: "📞 Contacto", color: "#e67e22" }
              ].map((item, index) => (
                <li key={index} style={{ margin: '0 5px' }}>
                  <a 
                    href={item.href} 
                    className="page-scroll"
                    onClick={() => setMobileMenuOpen(false)}
                    style={{
                      color: '#2c3e50',
                      fontWeight: '600',
                      fontSize: '0.95em',
                      padding: '12px 18px',
                      borderRadius: '25px',
                      transition: 'all 0.3s ease',
                      textDecoration: 'none',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = item.color;
                      e.target.style.color = 'white';
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = `0 8px 20px ${item.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'transparent';
                      e.target.style.color = '#2c3e50';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
            
          </div>
        </div>
      </nav>
    </>
  );
};
